import { Pipe, PipeTransform } from '@angular/core';
import { I18nTranslator } from '../i18n/translate';
import { Variety } from '../models/lists.model';

@Pipe({
  name: 'varietyLabel',
  standalone: true,
})
export class VarietyLabelPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(variety: Variety, args: any): any {
    if (variety.label) {
      return variety.label;
    }

    const varieties: Variety[] = args[0];
    const specyId = +args[1];
    const filtered = varieties.filter((variety) => variety.specy.id === specyId);

    if (filtered.length === 1) {
      return this.i18nTranslator.translate('parcel.edit.variete.all');
    }
    return this.i18nTranslator.translate('parcel.edit.variete.autre');
  }
}
